const emailValidationRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;

export const isValidEmail = (email: string) => {
  return email.length ? emailValidationRegex.test(email) : true;
};

const validCognitoUsernameRegex =
  /[^_\p{Z}][\p{L}\p{M}\p{S}\p{N}\p{P}][^_\p{Z}]+/u;

export const isValidCognitoUsername = (username: string) => {
  return validCognitoUsernameRegex.test(username) || true; // TODO: Remove true
};

const validCognitoPasswordRegex =
  /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;

export const isValidPassword = (password: string) => {
  return validCognitoPasswordRegex.test(password);
};
